export default __webpack_public_path__ + "static/restaurant_2-a6298777f67cbfca31328e05472da1cd.webp";